import request from "./curl";
import utility from "./utility";

var chatgrp_utility = {
  /**
   * chatgrp_user_add
   */
  chatgrp_user_add(self, group_id) {
    self.chatgrp_add_loader = true;
    var post_data = new FormData();
    post_data.append("chat_user_id", self.userData.user_id);
    post_data.append("group_id", group_id);

    request.curl(self, "group_user_add", post_data)
      .then(async response => {
        if (response.resp_status) {
          let new_grp = response.resp_data;

          self.data = await self.getChatgrpList;

          self.err_msg = response.resp_msg;
          self.snackbar = true;
          self.chatgrp_add_loader = false;

          self.$store.commit('setUserProfile', self.userData);
          await self.$store.commit('setSelectedGroup', group_id);

          new_grp['last_msg_sender'] = response.resp_data_1.sender_name;
          new_grp['last_msg'] = response.resp_data_1.text_msg;
          new_grp['last_message_id'] = (response.resp_data_1.self_message_id) ? response.resp_data_1.self_message_id : '';
          new_grp['last_msg_time'] = utility.get_message_datetime(response.resp_data_1.message_time, 'DD/MM/YYYY');
          new_grp['last_message_content_type'] = (response.resp_data_1.message_content_type) ? response.resp_data_1.message_content_type : '';

          //self.data.unshift(new_grp); //Move to Top
          await self.$store.commit('setChatgrpList', self.data);

          self.get_groups();
        }
        else {
          self.err_msg = response.resp_msg;
          if (response.resp_code !== 'ERR_GROUP_PARTICIPANT_ALREADY_EXISTS') {
            self.snackbar = true;
          }

          if (response.resp_code === 'ERR_GROUP_PARTICIPANT_ALREADY_EXISTS') {
            self.chatgrp_add_loader = false;
            await self.$store.commit('setSelectedGroup', group_id);
            self.get_groups();
          }
          else {
            if (self.userData && self.userData.chats) {
              //There was some error, send the user to the first chat in the userprofile list
              setTimeout(() => {
                self.chatgrp_add_loader = false;
                self.get_groups();
              }, 3000);
            }
            else {
              //There was some error, send the user to home as user is not a part of the chats
              setTimeout(() => {
                self.chatgrp_add_loader = false;
                self.$router.push('/')
              }, 1000);
            }
          }
        }
      });
  },
};

export default chatgrp_utility;
